import type { ComponentProps, ReactNode } from "react";
import {
  VideoPageBannerSection,
  VideoPageFooterSection,
  VideoPageHeaderSection,
  VideoPageHeroSection,
  VideoPageLogoSliderSection,
} from "@commerce-core/react-components";
import type { VideoPageBuilderSection } from "@/types/api.types";

type SectionRendererProps = {
  section: VideoPageBuilderSection;
};

function componentProps<TProps>(data: unknown): TProps {
  return data as TProps;
}

function renderSectionContent(section: VideoPageBuilderSection): ReactNode {
  switch (section.acf_fc_layout) {
    case "video_page_header":
      if (section.data.variant === "none") {
        return null;
      }

      return (
        <VideoPageHeaderSection
          {...componentProps<ComponentProps<typeof VideoPageHeaderSection>>(
            section.data,
          )}
        />
      );

    case "video_page_hero":
      return (
        <VideoPageHeroSection
          {...componentProps<ComponentProps<typeof VideoPageHeroSection>>(
            section.data,
          )}
        />
      );

    case "video_page_logo_slider":
      return (
        <VideoPageLogoSliderSection
          {...componentProps<ComponentProps<typeof VideoPageLogoSliderSection>>(
            section.data,
          )}
        />
      );

    case "video_page_banner":
      return (
        <VideoPageBannerSection
          {...componentProps<ComponentProps<typeof VideoPageBannerSection>>(
            section.data,
          )}
        />
      );

    case "video_page_footer":
      return (
        <VideoPageFooterSection
          {...componentProps<ComponentProps<typeof VideoPageFooterSection>>(
            section.data,
          )}
        />
      );

    default:
      return null;
  }
}

export function SectionRenderer({ section }: SectionRendererProps) {
  const content = renderSectionContent(section);

  if (!content) {
    return null;
  }

  return (
    <div id={section.anchorId} data-section-anchor="">
      {content}
    </div>
  );
}
